import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  );
}
